import { render, staticRenderFns } from "./PointsContractService.vue?vue&type=template&id=0730607c&scoped=true&"
import script from "./PointsContractService.vue?vue&type=script&lang=js&"
export * from "./PointsContractService.vue?vue&type=script&lang=js&"
import style0 from "./PointsContractService.vue?vue&type=style&index=0&id=0730607c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0730607c",
  null
  
)

export default component.exports